import React, { useCallback, useEffect, useState } from 'react';
import { getMyPaymentHistory } from '../../../api/payment/payment.api';
import PaymentsRow from './PaymentsRow';
import JobBoardPagination from '../../JobBoard/JobBoardPagination';

const MOBILE_PAGE_SIZE = 7;
const DESKTOP_PAGE_SIZE = 20;

const PaymentsList = ({ currentFilter, onDataChange, $isMobile }) => {
  const [paymentsList, setPaymentsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const pageSize = $isMobile ? MOBILE_PAGE_SIZE : DESKTOP_PAGE_SIZE;

  const fetchHistory = useCallback(
    async (pageToLoad, { append = false } = {}) => {
      setIsLoading(true);
      try {
        const data = await getMyPaymentHistory(
          pageToLoad - 1,
          pageSize,
          currentFilter,
        );
        const content = data.content || [];

        setPaymentsList((prev) => (append ? [...prev, ...content] : content));
        setTotalPages(data.totalPages || 1);
        onDataChange?.();
      } catch (error) {
        console.error('결제 내역을 불러오지 못했습니다.', error);
      } finally {
        setIsLoading(false);
      }
    },
    [currentFilter, pageSize, onDataChange],
  );

  useEffect(() => {
    setCurrentPage(1);
    fetchHistory(1, { append: false });
  }, [currentFilter, fetchHistory]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchHistory(pageNumber, { append: false });
    window.scrollTo(0, 0);
  };

  const handleViewMore = () => {
    const next = currentPage + 1;
    setCurrentPage(next);
    fetchHistory(next, { append: true });
  };

  const hasMore = currentPage < totalPages;

  const containerClass = $isMobile
    ? `w-full flex flex-col gap-6 ${hasMore && 'pb-4'}`
    : 'w-full flex flex-col rounded-[30px] overflow-hidden px-2 pt-4 pb-10 bg-grayscale-gray00 gap-10 -mt-5 relative z-10';

  return (
    <div className={containerClass}>
      <div className={$isMobile ? 'flex flex-col gap-3' : ''}>
        {paymentsList.length === 0 && isLoading ? (
          <div className='w-full p-10 flex justify-center text-text-placeholder typo-b14'>
            Loading...
          </div>
        ) : paymentsList.length === 0 ? (
          <div className='w-full p-10 flex items-center justify-center text-text-placeholder typo-b14 h-[380px]'>
            <div className='pb-6'>No payment history yet</div>
          </div>
        ) : (
          paymentsList.map((item, index) => (
            <PaymentsRow
              key={item.bookingId ?? `${item.invoiceNo}-${index}`}
              item={item}
              onExpire={() => fetchHistory(1, { append: false })}
              $isMobile={$isMobile}
            />
          ))
        )}
      </div>

      {$isMobile ? (
        hasMore && (
          <button
            type='button'
            onClick={handleViewMore}
            disabled={isLoading}
            className='w-full py-3 typo-b14Strong text-text-secondary disabled:opacity-50'
          >
            {isLoading ? 'Loading...' : 'View more'}
          </button>
        )
      ) : (
        <JobBoardPagination
          isMyPage
          current={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default PaymentsList;
